import DIApi from './_diApi';

class BudgetProvideAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetProvides';
}

export default new BudgetProvideAPI();
